var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "report-channel-breakdown" } }, [
    _c("div", { staticClass: "overall-content" }, [
      _c(
        "div",
        { staticClass: "chart-container" },
        [
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c("div", { staticClass: "title" }, [
                _c(
                  "div",
                  { staticClass: "icon-wrapper" },
                  [_c("WhatsappIcon", { attrs: { color: "#59C864" } })],
                  1
                ),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("report.whatsappChannelDistribution"))),
                ]),
              ]),
              _vm._v(" "),
              _c("ChannelOverallChart", {
                attrs: {
                  title: _vm.$t("report.whatsappChannelDistribution"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.whatsapp,
                  channelType: "whatsapp",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c("div", { staticClass: "title" }, [
                _c(
                  "div",
                  { staticClass: "icon-wrapper" },
                  [_c("InstagramIcon")],
                  1
                ),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("report.instagramChannelDistribution"))),
                ]),
              ]),
              _vm._v(" "),
              _c("ChannelOverallChart", {
                attrs: {
                  title: _vm.$t("report.instagramChannelDistribution"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.instagram,
                  channelType: "instagram",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c("div", { staticClass: "title" }, [
                _c(
                  "div",
                  { staticClass: "icon-wrapper" },
                  [_c("MessengerIcon")],
                  1
                ),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("report.messengerChannelDistribution"))),
                ]),
              ]),
              _vm._v(" "),
              _c("ChannelOverallChart", {
                attrs: {
                  title: _vm.$t("report.messengerChannelDistribution"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.messenger,
                  channelType: "messenger",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c("div", { staticClass: "title" }, [
                _c(
                  "div",
                  { staticClass: "icon-wrapper" },
                  [_c("TrendyolIcon")],
                  1
                ),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("report.trendyolChannelDistribution"))),
                ]),
              ]),
              _vm._v(" "),
              _c("ChannelOverallChart", {
                attrs: {
                  title: _vm.$t("report.trendyolChannelDistribution"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.trendyol,
                  channelType: "trendyol",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c("div", { staticClass: "title" }, [
                _c("div", { staticClass: "icon-wrapper" }, [_c("MetaIcon")], 1),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("report.metaLeadsChannelDistribution"))),
                ]),
              ]),
              _vm._v(" "),
              _c("ChannelOverallChart", {
                attrs: {
                  title: _vm.$t("report.metaLeadsChannelDistribution"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.metaLeads,
                  channelType: "meta-leads",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c("div", { staticClass: "title" }, [
                _c(
                  "div",
                  { staticClass: "icon-wrapper" },
                  [_c("TelegramIcon")],
                  1
                ),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(
                    _vm._s(_vm.$t("report.chatDistributionByTelegramChannels"))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("ChannelOverallChart", {
                attrs: {
                  title: _vm.$t("report.chatDistributionByTelegramChannels"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.telegram,
                  channelType: "telegram",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c("div", { staticClass: "title" }, [
                _c(
                  "div",
                  { staticClass: "icon-wrapper" },
                  [_c("LinkedinIcon")],
                  1
                ),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(
                    _vm._s(_vm.$t("report.chatDistributionByLinkedinChannels"))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("ChannelOverallChart", {
                attrs: {
                  title: _vm.$t("report.chatDistributionByLinkedinChannels"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.linkedin,
                  channelType: "linkedin",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }